/** Onde cada função mora na tela e onde fica o ponto pulsando dela. */
import type { ItemDoTour } from '@/stores/guidedTourStore'

export const ALVO_DO_ITEM: Record<ItemDoTour, string> = {
  equipe: '[data-testid="sidebar-settings-btn"]',
  voz: '[data-testid="mic-btn"]',
  comandos: '[data-testid="chat-input"]',
  indicadores: '[data-testid="indicadores-btn"]',
}

/** No máximo dois pontos por vez: a ajuda não vem toda de uma vez. */
export const MAXIMO_DE_PONTOS = 2
/** Lado do ponto (alvo de toque confortável em tablet). */
export const LADO_DO_PONTO = 28

export interface PontoNaTela {
  item: ItemDoTour
  top: number
  left: number
}

/** Posição do ponto sobre o canto superior direito do alvo, ou `null` se o alvo não está visível. */
export function posicaoDoPonto(
  item: ItemDoTour,
  doc: Document = document,
  janela: { innerWidth: number; innerHeight: number } = window,
): PontoNaTela | null {
  const el = doc.querySelector(ALVO_DO_ITEM[item])
  if (!el) return null
  const r = el.getBoundingClientRect()
  if (r.width === 0 || r.height === 0) return null
  if (r.right <= 0 || r.bottom <= 0 || r.left >= janela.innerWidth || r.top >= janela.innerHeight) return null
  const meio = LADO_DO_PONTO / 2
  const left = Math.min(Math.max(r.right - meio, 0), janela.innerWidth - LADO_DO_PONTO)
  const top = Math.min(Math.max(r.top - meio, 0), janela.innerHeight - LADO_DO_PONTO)
  return { item, top, left }
}
